import styled from "styled-components";

import Button from "@/components/Atoms/Button";
import theme from "@/foundation/Theme";

const ProgramContainer = styled.div`
  background-color: ${theme.colorsV2.rose.shade_50};
  padding: 88px 140px 118px 140px;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 24px 16px 104px 16px;
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CardContainer = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    margin-top: 20px;
  }
`;

const Card = styled.div`
  padding: 30px 20px 30px 20px;
  border-radius: 16px;
  background-color: ${theme.colors.white};

  @media screen and (max-width: 600px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 20px;
  }
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: ${theme.colorsV2.shyft.cream};
`;

const TextContainer = styled.div`
  @media screen and (max-width: 600px) {
    width: 256px;
    margin-left: 20px;
  }
`;

const StyledButton = styled(Button)`
  position: absolute;
  width: 870px;
  padding: 40px 61px 40px 61px;
  border-radius: 32px;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 50%);

  @media screen and (max-width: 600px) {
    padding: 40px;
    width: 380px;
    left: 50%px;
    bottom: 0px;

    transform: translate(-50%, 50%);
  }
`;

const Container = styled.div`
  background-color: ${theme.colors.white};
  padding-bottom: 50px;
  @media screen and (max-width: 600px) {
    padding-bottom: 40px;
  }
`;

export {
  ProgramContainer,
  HeadingContainer,
  CardContainer,
  Card,
  IconContainer,
  TextContainer,
  StyledButton,
  Container,
};
